///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { accordionFeatureKey } from './accordion.state';
import { reducer } from './accordion.reducers';
import { AccordionEffects } from './effects/accordion.effects';
import { GtthCustomerService } from '../../../services/customer/customer.service';

@NgModule({
    declarations: [],
    imports: [CommonModule, StoreModule.forFeature(accordionFeatureKey, reducer), EffectsModule.forFeature([AccordionEffects])],
    providers: [GtthCustomerService]
})
export class AccordionStoreModule {}
